import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import t from '../../shared/translations';

interface IProps {
    setCopied: (value: boolean) => void;
}

const Holder = styled.div`
    color: ${colors.primaryColor};
    white-space: nowrap;
    display: flex;
    align-items: center;
`;

function CopiedText({ setCopied }: IProps): JSX.Element {
    React.useEffect(() => {
        const timer = setTimeout(() => setCopied(false), 10000);
        return () => {
            clearTimeout(timer);
        };
    }, []);
    return <Holder>
        {t('player.pulse-results.info-link-copied')}
    </Holder>;
}

export default CopiedText;
